import {
  AnyDataPayload,
  getCollectionNameFromUnfurlData as getCollectionNameFromUnfurlDataImpl,
} from '@lib/external/unfurl';

export class URLService {
  private static instance: URLService;
  private constructor() {}

  static getInstance(): URLService {
    if (!URLService.instance) {
      URLService.instance = new URLService();
    }
    return URLService.instance;
  }

  // Debounced URL handler
  createDebouncedHandler(
    callback: (url: string) => void,
    delay: number = 800,
  ): (url: string) => void {
    let timeout: NodeJS.Timeout | null = null;

    return (url: string) => {
      if (timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(() => callback(url), delay);
    };
  }

  /**
   * Extract suggested library name from unfurl data.
   * Now works with AnyDataPayload directly.
   */
  getCollectionNameFromUnfurlData(unfurlData: AnyDataPayload | null, defaultName: string): string {
    if (!unfurlData) return defaultName;
    return getCollectionNameFromUnfurlDataImpl(unfurlData, defaultName);
  }
}
